module.exports = __webpack_public_path__ + "img/hk2.3ae2a9e4.png";